exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "map-details-overlay{display:block;position:relative}.mapDetailsOverlay{width:100%;background-color:bisque;border-bottom:1px solid #c76b00;padding:10px;overflow:auto}.mapDetailsOverlay--detailsTitle{font-weight:700;text-transform:capitalize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/components/mapDetailsOverlay/mapDetailsOverlay.styl
// module id = 780
// module chunks = 0